import { useTranslation } from 'react-i18next';
import { AlertTriangle, Sparkles } from 'lucide-react';

const KNOWN_CATEGORIES = [
  'violence',
  'sexual',
  'drugs',
  'profanity',
  'discrimination',
  'horror',
  'trademark',
  'other',
] as const;

export type DeclineCategory = (typeof KNOWN_CATEGORIES)[number];

interface Props {
  category: DeclineCategory | null;
  softening: boolean;
  onSoften: () => void;
}

export default function ContentDeclineBanner({ category, softening, onSoften }: Props) {
  const { t } = useTranslation();
  const safeCategory: DeclineCategory =
    category && (KNOWN_CATEGORIES as readonly string[]).includes(category)
      ? (category as DeclineCategory)
      : 'other';

  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 flex items-start gap-3">
      <AlertTriangle className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <p className="text-sm font-medium text-amber-900">{t('create.declineHeading')}</p>
        <p className="text-sm text-amber-800">{t(`create.declineReason.${safeCategory}`)}</p>
        <button
          type="button"
          onClick={onSoften}
          disabled={softening}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm bg-primary text-white hover:bg-primary/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
        >
          <Sparkles className={`w-3.5 h-3.5 ${softening ? 'animate-pulse' : ''}`} />
          {softening ? t('create.softening') : t('create.softenAction')}
        </button>
      </div>
    </div>
  );
}
